export const getBaseDomain = () => {
    // 🚀 Проверяем, запущены ли мы на локалке
    const isLocal = window.location.hostname.endsWith('.localhost') ||
        window.location.hostname === 'localhost';

    if (isLocal) {
        return `http://api.orioncode.localhost`;
    }

    return `https://api.orioncode.ru`;
};

export const BASE_DOMAIN = getBaseDomain();

// Базовый URL для API
export const API_URL = `${getBaseDomain()}/api`;

// Универсальный URL для WebSocket
export const getWsUrl = () => {
    const isLocal = window.location.hostname.endsWith('.localhost') ||
        window.location.hostname === 'localhost';

    if (isLocal) {
        // На локалке используем обычный ws:// без SSL
        return `ws://ws.orioncode.localhost`;
    }

    return `wss://ws.orioncode.ru`;
};

export const WS_URL = getWsUrl();
